import {
  LOADING, GET_DOCUMENT_TYPE, GET_ASSISTANT_ADDRESS,
  GET_STATES_LIST, SET_PURCHASE_PARAMETERS,
  SET_REJECT_TYPES, SET_APP_NAME, SET_SERVICE_TYPES,
  GET_FEATURE_TYPES, SET_VALUE_TAB, GET_PARAMETER_COMBO,
  GENERAL_SHOW_MESSAGE, SET_PARAMETER_APP, SET_TENANT,
  SET_STATES_AND_CITIES, GET_PARAMETERS_MARKET,
  SET_CUSTOMER_PARAMETERS, SET_CREATE_CUSTOMER_PARAMETERS,
  SET_CREATE_COUNTRIES_LIST,
} from '../types/general.type';

const INITIAL_STATE = {
  appName: undefined,
  loading: false,
  showMessageAlert: undefined,
  assistantAddress: undefined,
  documentTypes: [],
  parameterCombo: [],
  statesAndCities: undefined,
  citiesList: [],
  rejectTypes: [],
  serviceTypes: [],
  valueTabBackOffice: 0,
  applicationInfo: undefined,
  versionInfo: null,
  parameterApp: {},
  tenant: undefined,
  countryCodeFromUrl: undefined,
  getParametersMarket: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_APP_NAME:
      return {
        ...state,
        appName: action.payload,
      };
    case GET_DOCUMENT_TYPE:
      return {
        ...state,
        documentTypes: action.payload,
      };
    case GET_PARAMETER_COMBO:
      return {
        ...state,
        parameterCombo: action.payload,
      };
    case GET_ASSISTANT_ADDRESS:
      return {
        ...state,
        assistantAddress: {
          itemsAddress: action.payload.itemsAddress,
          itemsAddressLetters: action.payload.itemsAddressLetters,
          itemsAddressBis: action.payload.itemsAddressBis,
          itemsAddressCardinal: action.payload.itemsAddressCardinal,
        },
      };
    case GET_STATES_LIST:
      return {
        ...state,
        statesAndCities: {
          statesList: action.payload.statesList,
          itemsStatesList: action.payload.itemsStatesList,
        },
      };
    case SET_PURCHASE_PARAMETERS:
      return {
        ...state,
        documentTypes: action.payload.docTypes,
        assistantAddress: {
          itemsAddress: action.payload.assistantAddressTypes.itemsAddress,
          itemsAddressLetters: action.payload.assistantAddressTypes.itemsAddressLetters,
          itemsAddressBis: action.payload.assistantAddressTypes.itemsAddressBis,
          itemsAddressCardinal: action.payload.assistantAddressTypes.itemsAddressCardinal,
        },
        statesAndCities: {
          statesList: action.payload.statesAndCities.statesList,
          itemsStatesList: action.payload.statesAndCities.itemsStatesList,
        },
        applicationInfo: action.payload.application,
      };
    case SET_REJECT_TYPES:
      return {
        ...state,
        rejectTypes: action.payload,
      };
    case SET_SERVICE_TYPES:
      return {
        ...state,
        serviceTypes: action.payload,
      };
    case GET_FEATURE_TYPES:
      return {
        ...state,
        featureTypes: action.payload,
      };
    case SET_VALUE_TAB:
      return {
        ...state,
        valueTabBackOffice: action.payload,
      };
    case GENERAL_SHOW_MESSAGE:
      return {
        ...state,
        showMessageAlert: action.payload,
      };
    case SET_PARAMETER_APP:
      return {
        ...state,
        parameterApp: action.payload,
      };
    case SET_TENANT:
      return {
        ...state,
        tenant: action.payload,
      };
    case SET_STATES_AND_CITIES:
      return {
        ...state,
        statesAndCities: action.payload,
      };
    case GET_PARAMETERS_MARKET:
      return {
        ...state,
        getParametersMarket: action.payload,
      };
    case SET_CUSTOMER_PARAMETERS:
      return {
        ...state,
        documentTypes: action.payload.docTypes,
        assistantAddress: {
          itemsAddress: action.payload.assistantAddressTypes.itemsAddress,
          itemsAddressLetters: action.payload.assistantAddressTypes.itemsAddressLetters,
          itemsAddressBis: action.payload.assistantAddressTypes.itemsAddressBis,
          itemsAddressCardinal: action.payload.assistantAddressTypes.itemsAddressCardinal,
        },
        statesAndCities: {
          statesList: action.payload.statesAndCities.statesList,
          itemsStatesList: action.payload.statesAndCities.itemsStatesList,
        },
        countriesList: action.payload.countriesList,
      };
    case SET_CREATE_CUSTOMER_PARAMETERS:
      return {
        ...state,
        createDocumentTypes: action.payload.docTypes,
        createStatesAndCities: action.payload.statesAndCities,
      };

    case SET_CREATE_COUNTRIES_LIST:
      return {
        ...state,
        createCountriesList: action.payload,
      };
    default:
      return state;
  }
};
